export function isValidNumericString(str: string) {
  if (typeof str != "string") return false
  // @ts-ignore
  return !isNaN(str) && !isNaN(parseFloat(str))
}